import { site } from '@/data/site';
import type { GameData } from '@/data/games';

interface StickyDownloadBarProps {
  game: GameData;
}

export default function StickyDownloadBar({ game }: StickyDownloadBarProps) {
  const downloadUrl = game.downloadUrl || site.affiliateUrl;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-background-200">
      <div className="max-w-[480px] mx-auto px-4 py-2 flex items-center gap-3">
        <img
          src={game.imageUrl}
          alt={game.shortName}
          width={36}
          height={36}
          className="w-9 h-9 rounded-lg object-cover flex-shrink-0"
          onError={(e) => {
            const t = e.currentTarget;
            t.style.display = 'none';
            const fallback = document.createElement('div');
            fallback.className = `w-9 h-9 rounded-lg ${game.iconBg} flex items-center justify-center flex-shrink-0`;
            fallback.innerHTML = '<i class="ri-gamepad-line text-sm text-white"></i>';
            t.parentNode?.insertBefore(fallback, t);
          }}
        />
        <span className="text-[13px] font-semibold text-foreground-900 truncate flex-1">
          {game.shortName}
        </span>
        <a
          href={downloadUrl}
          target="_blank"
          rel="sponsored nofollow noopener noreferrer"
          className="px-4 py-2 bg-primary-500 text-white rounded-lg text-xs font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          Download
        </a>
      </div>
    </div>
  );
}